export const testimonials = [
  {
    name: "网友 · 阿初",
    role: "连续参与三届",
    text: "别的榜单只给个名次，这里能直接看到分数走势，谁是真冲上来的、谁是吃老本的一眼就分得清。",
  },
  {
    name: "网友 · 小满",
    role: "神评论分类常客",
    text: "我投的那件作品从第八名一路爬到第二，那种参与感是刷榜看一眼比不了的。",
  },
  {
    name: "社区管理员 · 老K",
    role: "合作社区代表",
    text: "先审后展这块做得比较扎实，我们社区把投稿导过来的时候，基本不用担心内容质量参差不齐。",
  },
];

export const principles = [
  {
    icon: "ri-eye-line",
    title: "先审后展",
    desc: "所有内容在上线前完成初审，不实信息与涉及隐私的内容不会进入入围名单。",
  },
  {
    icon: "ri-scales-3-line",
    title: "分数可追溯",
    desc: "每件作品的分数变化都留有记录，评委去极值后取平均，避免个别人操纵结果。",
  },
  {
    icon: "ri-heart-line",
    title: "尊重当事人",
    desc: "涉及具体个人的内容，只要可能造成困扰，我们都会在展示前进行模糊化处理。",
  },
  {
    icon: "ri-refresh-line",
    title: "每届重构",
    desc: "每届的入围名单与分类都会重新生成，不沿用旧榜单，让新作品有同等的机会。",
  },
];

export const milestones = [
  { year: "第一届", title: "从社区小投票起步", desc: "最初的爆料大赛只是社区里的一次小投票，只有几十件投稿。" },
  { year: "第三届", title: "引入群众打分机制", desc: "去掉极值取平均的评分方式正式上线，榜单开始变得可信。" },
  { year: "第五届", title: "分类独立评比", desc: "把名场面、反转、花絮等拆成独立分类，不同风格的作品都能被看见。" },
  { year: "本届", title: "走势透明化", desc: "新增 24 小时分数走势展示，冲榜过程第一次完整呈现在大家面前。" },
];